<template>
	<span class="clipped-text" :title="hoverTitle" :aria-label="hoverTitle">{{
		displayText
	}}</span>
</template>

<script>
/**
 * Reusable wrapper that clips long strings to a character limit.
 * Hovering a clipped value shows the full string in the native title tooltip.
 */
export default {
	/**
	 * The component's computed properties.
	 *
	 * @type {Object}
	 */
	computed: {
		/**
		 * Normalized source string used for clipping and hover title.
		 *
		 * @return {String}
		 */
		normalizedText() {
			if (this.text == null) {
				return ''
			}

			return String(this.text).trim()
		},

		/**
		 * Whether the source string exceeds the character limit.
		 *
		 * @return {Boolean}
		 */
		isClipped() {
			return this.normalizedText.length > this.length
		},

		/**
		 * Clipped display value with an ellipsis when the text is too long.
		 *
		 * @return {String}
		 */
		displayText() {
			if (!this.isClipped) {
				return this.normalizedText
			}

			return `${this.normalizedText.slice(0, this.length)}...`
		},

		/**
		 * Full string for the hover tooltip when the value is clipped.
		 *
		 * @return {String|undefined}
		 */
		hoverTitle() {
			if (!this.isClipped) {
				return undefined
			}

			return this.normalizedText
		},
	},

	/**
	 * The component's name used for debugging.
	 *
	 * @type {String}
	 */
	name: 'ClippedText',

	/**
	 * The component's inherited properties.
	 *
	 * @type {Object}
	 */
	props: {
		/**
		 * Maximum number of characters to show before clipping.
		 *
		 * @type {Number}
		 */
		length: {
			type: Number,
			default: 50,
			validator(value) {
				return Number.isInteger(value) && value >= 0
			},
		},

		/**
		 * The string to clip.
		 *
		 * @type {String}
		 */
		text: {
			type: [String, Number],
			default: '',
		},
	},
}
</script>
